import * as Yup from 'yup';
import {IModel} from '~/lib/model';

export interface IFeeOverrideSetting extends IModel {
    adType?: string;
    country?: string;
    scale: number;
    fee: number;
}

export const FeeOverrideSettingSchema = Yup.object().shape<IFeeOverrideSetting>({
    id: null,
    adType: Yup.string().nullable().when(['country'], {
        is: (country) => !country,
        then: Yup.string().required('is required')
    }),
    country: Yup.string().nullable().when(['adType'], {
        is: (adType) => !adType,
        then: Yup.string().required('is required')
    }),
    scale: Yup.number().min(0).required('is required').typeError('you must specify a number'),
    fee: Yup.number().min(0).required('is required').typeError('you must specify a number'),
}, [['adType', 'country']]);

export const defaultFeeOverrideSetting: IFeeOverrideSetting = {
    id: null,
    adType: null,
    country: null,
    scale: 0.0,
    fee: 0.0
};
